const toUSD = function (input) {
  let digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if ((input || input === 0) && !isNaN(Number(input))) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: digits,
      minimumFractionDigits: digits
    }).format(Math.abs(Number(input)));
  }
  return '';
};
const startCase = function (input) {
  let delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
  return input.split(delimiter).map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(delimiter);
};
const isEmpty = value => {
  return value == null || typeof value === 'object' && Object.keys(value).length === 0 || typeof value === 'string' && value.trim().length === 0;
};
const isNullOrUndefined = value => {
  return !value && value !== 0;
};
const getFileType = fileName => {
  const index = fileName.lastIndexOf('.');
  const type = index < fileName.length ? fileName.substring(index + 1).toUpperCase() : 'FILE';
  return type;
};
const getFileSize = size => {
  if (size) {
    var fileSize = (size / 1000000).toFixed(2);
    var isKiloByte = false;
    if (fileSize === '0.00') {
      fileSize = (size / 1000).toFixed(2);
      isKiloByte = true;
    }
    return isKiloByte ? fileSize + ' KB' : fileSize + ' MB';
  } else {
    return '0KB';
  }
};
const toLocalString = value => {
  return !value ? '' : `$${value.toLocaleString()}`;
};
const formatPropertyAddress = address => {
  return Object.values(address).filter(value => !isEmpty(value)).join(', ');
};
const getTextOrCurrencyText = value => {
  const currencyText = toUSD(value, 0);
  if (!currencyText && value) return value;
  console.log(value, currencyText);
  return currencyText;
};

// Return the content wrapped with [], ex : [header] => header
const getTextByContent = data => {
  return data.metadata.values[data.content.slice(1, -1)];
};
const textReplacer = (text, data) => {
  let re = /\[(.*?)]/g,
    specialRegEx = /([!@#\\$%^&*)(+=.,_-]$)/g,
    match;
  let result = [];
  const tokenized = text.split(' ');
  if (Array.isArray(tokenized) && tokenized.length) {
    tokenized.forEach(value => {
      if (match = re.exec(value)) {
        if (match && match[1]) {
          const contentMatch = `${Functions.getTextOrCurrencyText(data[match[1]])}`;
          const withMatch = re.exec(contentMatch);
          re.lastIndex = 0;
          const specialMatch = specialRegEx.exec(match.input);
          result.push({
            content: specialMatch && specialMatch[0] && specialMatch.index > 0 ? `${Functions.getTextOrCurrencyText(data[match[1]])}${match.input.substring(specialMatch.index)} ` : Array.isArray(re.exec(contentMatch)) ? withMatch ? contentMatch.replace(withMatch[0],
            //@ts-ignore
            `${Functions.getTextOrCurrencyText(data[withMatch[1]])}`) : contentMatch : contentMatch,
            type: 'text'
          });
        } else {
          result.push({
            content: `${value} `,
            type: 'text'
          });
        }
      } else {
        result.push({
          content: `${value} `,
          type: 'text'
        });
      }
    });
  }
  return result;
};
const Functions = {
  toUSD,
  startCase,
  isEmpty,
  isNullOrUndefined,
  getFileType,
  getFileSize,
  toLocalString,
  formatPropertyAddress,
  getTextOrCurrencyText,
  getTextByContent,
  textReplacer
};
export default Functions;
//# sourceMappingURL=index.js.map